<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>MAPA DE CALOR</h1>
        </div>
        @if(environment.name==="prod"){
        <iframe
            title="heat_map_observatory_prod"
            width="100%"
            height="700"
            src="https://app.powerbi.com/view?r=eyJrIjoiZjYwMzI2MWYtYWNiYS00ODEwLThiZWUtODQ3MWYxMjlkYTBmIiwidCI6ImVjYWZiM2EyLWE2Y2YtNDI2NC05NTVlLWUxODFiNzRjNmFhZSIsImMiOjR9&pageName=8a0b16628816b1f68667"
            frameborder="0"
            allowFullScreen="true"
        ></iframe>
        }@else{
        <iframe
            title="heat_map_observatory_dev"
            width="100%"
            height="700"
            src="https://app.powerbi.com/view?r=eyJrIjoiZjYwMzI2MWYtYWNiYS00ODEwLThiZWUtODQ3MWYxMjlkYTBmIiwidCI6ImVjYWZiM2EyLWE2Y2YtNDI2NC05NTVlLWUxODFiNzRjNmFhZSIsImMiOjR9&pageName=8a0b16628816b1f68667"
            frameborder="0"
            allowFullScreen="true"
        ></iframe>
        }
    </div>
</div>
